import {
  BasicInfoRegister,
  DocumentUpload,
  OtpVerify,
} from "@/components/register-flow";
import { RegisterContext } from "@/context";
import { useContext } from "react";

export const RenderRegisterForm = () => {
  const { activeStep } = useContext(RegisterContext);

  if (activeStep === 0) {
    return <BasicInfoRegister />;
  }
  if (activeStep === 1) {
    return <OtpVerify />;
  }
  if (activeStep === 2) {
    return <DocumentUpload />;
  }
  return null;
};

export default RenderRegisterForm;
